export const VOICE_SETUP_PENDING_MESSAGE = "Voice setup is pending. It will retry automatically."
export const VOICE_KNOWLEDGE_PENDING_MESSAGE = "Business knowledge is still being prepared."
export const VOICE_SETUP_FAILED_MESSAGE = "Voice setup could not finish. Please contact support."

export function isVoiceSyncPending(message: string | null | undefined): boolean {
  return message === VOICE_SETUP_PENDING_MESSAGE || message === VOICE_KNOWLEDGE_PENDING_MESSAGE
}
